import { render, staticRenderFns } from "./AppToTop.vue?vue&type=template&id=634732c8&scoped=true&"
import script from "./AppToTop.vue?vue&type=script&lang=js&"
export * from "./AppToTop.vue?vue&type=script&lang=js&"
import style0 from "./AppToTop.vue?vue&type=style&index=0&id=634732c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634732c8",
  null
  
)

component.options.__file = "AppToTop.vue"
export default component.exports